import { defineMessages } from "react-intl";

const PREFIX = "YearSelectorControl";
const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
    defaultMessage: "Calendar",
  },
});

export default messages;
